import { MadadAgencyCard } from 'components/madad/entities';

export const newOffices: MadadAgencyCard[] = [];

export const legacyOffices: MadadAgencyCard[] = [];
